import { EventLog } from '@adornis/analytics/db/eventlog.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { type PartialEntityData } from '@adornis/baseql/entities/types.js';

// TODO the eventlogs in the following region seem to not be used anywhere, maybe delete?
// #region Exam Flow EventLogs

@Entity()
export class SlotsPassedEventLog extends EventLog {
  public static override _class = 'SlotsPassedEventLog';
  constructor(doc: PartialEntityData<SlotsPassedEventLog>) {
    super(doc);
  }

  @Field(type => [ID])
  public slotIDs!: string[];
}

@Entity()
export class SlotsFailedEventLog extends EventLog {
  public static override _class = 'SlotsFailedEventLog';
  constructor(doc: PartialEntityData<SlotsFailedEventLog>) {
    super(doc);
  }

  @Field(type => [ID])
  public slotIDs!: string[];
}

@Entity()
export class EnteredExamEventLog extends EventLog {
  public static override _class = 'enteredExam';
  constructor(doc: PartialEntityData<EnteredExamEventLog>) {
    super(doc);
  }
  @Field(type => ID)
  public examDay!: string;
}

@Entity()
export class StartedExamSlotEventLog extends EventLog {
  public static override _class = 'startedSlot';
  constructor(doc: PartialEntityData<StartedExamSlotEventLog>) {
    super(doc);
  }
  @Field(type => ID)
  public examSlot!: string;
}

@Entity()
export class FinishedExamSlotEventLog extends EventLog {
  public static override _class = 'finishedSlot';
  constructor(doc: PartialEntityData<FinishedExamSlotEventLog>) {
    super(doc);
  }
  @Field(type => ID)
  public examSlot!: string;
}

// #endregion

// #region mailing eventlogs

@Entity()
export class RegisterMailSentEventLog extends EventLog {
  public static override _class = 'registerMailSent';
  constructor(doc: PartialEntityData<RegisterMailSentEventLog>) {
    super(doc);
  }
  @Field(type => String)
  public recipient!: string;
}

@Entity()
export class OrderConfirmationMailSentEventLog extends EventLog {
  public static override _class = 'orderConfirmationMailSent';
  constructor(doc: PartialEntityData<OrderConfirmationMailSentEventLog>) {
    super(doc);
  }
  @Field(type => String)
  public recipient!: string;
}

@Entity()
export class OrderRefundMailSentEventLog extends EventLog {
  public static override _class = 'orderRefundMailSent';
  constructor(doc: PartialEntityData<OrderRefundMailSentEventLog>) {
    super(doc);
  }
  @Field(type => String)
  public recipient!: string;
}

@Entity()
export class ProblemMailSentEventLog extends EventLog {
  public static override _class = 'problemMailSent';
  constructor(doc: PartialEntityData<ProblemMailSentEventLog>) {
    super(doc);
  }
  @Field(type => String)
  public recipient!: string;
}

@Entity()
export class ExamDayInvitationMailSentEventLog extends EventLog {
  public static override _class = 'ExamDayInvitationMailSentEventLog';
  constructor(doc: PartialEntityData<ExamDayInvitationMailSentEventLog>) {
    super(doc);
  }

  @Field(type => String)
  public recipient!: string;
}

@Entity()
export class ExamEndedMailSentEventLog extends EventLog {
  public static override _class = 'examEndedMailSent';
  constructor(doc: PartialEntityData<ExamEndedMailSentEventLog>) {
    super(doc);
  }
  @Field(type => String)
  public recipient!: string;
}

@Entity()
export class ExamResultsMailSentEventLog extends EventLog {
  public static override _class = 'examResultsMailSentEventLog';
  constructor(doc: PartialEntityData<ExamResultsMailSentEventLog>) {
    super(doc);
  }
  @Field(type => String)
  public recipient!: string;
}

@Entity()
export class ExamCertificateMailSentEventLog extends EventLog {
  public static override _class = 'examCertificateMailSentEventLog';
  constructor(doc: PartialEntityData<ExamCertificateMailSentEventLog>) {
    super(doc);
  }
  @Field(type => String)
  public recipient!: string;
}

@Entity()
export class PasswordResetMailSentEventLog extends EventLog {
  public static override _class = 'passwordResetMailSentEventLog';
  constructor(doc: PartialEntityData<PasswordResetMailSentEventLog>) {
    super(doc);
  }
  @Field(type => String)
  public recipient!: string;
}

// #endregion

//#region Signup Flow Eventlogs

/**
 * @entity EventLogSignupSelectExamDayType
 */
@Entity()
export class EventLogSignupSelectExamDayType extends EventLog {
  static override _class = 'EventLogSignupSelectExamDayType';

  constructor(
    doc: PartialEntityData<EventLogSignupSelectExamDayType> &
      Required<Pick<EventLogSignupSelectExamDayType, 'examDayType'>>,
  ) {
    super(doc);
  }

  @Field(type => String)
  examDayType: Maybe<string>;
}

/**
 * @entity EventLogSignupSelectExamDay
 */
@Entity()
export class EventLogSignupSelectExamDay extends EventLog {
  static override _class = 'EventLogSignupSelectExamDay';

  constructor(
    doc: PartialEntityData<EventLogSignupSelectExamDay> & Required<Pick<EventLogSignupSelectExamDay, 'examDayID'>>,
  ) {
    super(doc);
  }

  @Field(type => String)
  examDayID: Maybe<string>;
}

/**
 * @entity EventLogSignupSetMailAndPasswordConfirm
 */
@Entity()
export class EventLogSignupSetMailAndPasswordConfirm extends EventLog {
  static override _class = 'EventLogSignupSetMailAndPasswordConfirm';

  constructor(doc: PartialEntityData<EventLogSignupSetMailAndPasswordConfirm>) {
    super(doc);
  }
}

/**
 * @entity EventLogSignupSetMailAndPasswordCancel
 */
@Entity()
export class EventLogSignupSetMailAndPasswordCancel extends EventLog {
  static override _class = 'EventLogSignupSetMailAndPasswordCancel';

  constructor(
    doc: PartialEntityData<EventLogSignupSetMailAndPasswordCancel> &
      Required<Pick<EventLogSignupSetMailAndPasswordCancel, 'examdayID'>>,
  ) {
    super(doc);
  }

  @Field(type => String)
  examdayID?: string;
}

/**
 * @entity EventLogSignupProfileDataConfirm
 */
@Entity()
export class EventLogSignupProfileDataConfirm extends EventLog {
  static override _class = 'EventLogSignupProfileDataConfirm';

  constructor(doc: PartialEntityData<EventLogSignupProfileDataConfirm>) {
    super(doc);
  }
}

/**
 * @entity EventLogSignupRegisterUser
 */
@Entity()
export class EventLogSignupRegisterUser extends EventLog {
  static override _class = 'EventLogSignupRegisterUser';

  constructor(
    doc: PartialEntityData<EventLogSignupRegisterUser> & Required<Pick<EventLogSignupRegisterUser, 'registeredUserID'>>,
  ) {
    super(doc);
  }

  @Field(type => String)
  registeredUserID?: string;
}

/**
 * @entity EventLogSignupPaymentStart
 */
@Entity()
export class EventLogSignupPaymentStart extends EventLog {
  static override _class = 'EventLogSignupPaymentStart';

  constructor(
    doc: PartialEntityData<EventLogSignupPaymentStart> & Required<Pick<EventLogSignupPaymentStart, 'examDayID'>>,
  ) {
    super(doc);
  }

  @Field(type => String)
  examDayID?: string;
}

// #endregion
